import * as React from 'react';
import ErrorPage from '../pageComponents/ErrorPage';
import { RouteComponentProps } from 'react-router';

export interface ErrorBoundaryProps extends RouteComponentProps<any> {
    children: any;
}

export interface ErrorBoundaryState {
    hasError: boolean;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);

        this.state = {hasError: false};
    }

    componentDidCatch(error: any, info: any) {
        console.log(error);
        
        // Display fallback UI
        this.setState({ hasError: true });
        // You can also log the error to an error reporting service
        // logErrorToMyService(error, info);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <ErrorPage {...this.props}/>;
        }
        return this.props.children;
    }
}
 


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/ErrorBoundary.tsx